import {
  MetaTouchpointSetup,
  TiktokTouchpointSetup,
  YouTubeTouchpointSetup,
} from '../interfaces';

const getSaturationMinEqualToMax = (
  minMaxValues?:
    | MetaTouchpointSetup
    | TiktokTouchpointSetup
    | YouTubeTouchpointSetup
) => {
  return (
    (minMaxValues?.saturationMin ?? 0) === (minMaxValues?.saturationMax ?? 1)
  );
};

export default getSaturationMinEqualToMax;
